export const removeItem = (_, payload) => payload.items.splice(payload.index, 1)
